import { useEffect, useRef } from 'react';
// @ts-ignore - wordcloud doesn't have types
import WordCloudLib from 'wordcloud';

interface WordCloudProps {
  words: Array<{ text: string; value: number }>;
  height?: number;
  width?: number;
}

const WordCloud: React.FC<WordCloudProps> = ({ 
  words, 
  height = 400, 
  width = 600 
}) => {
  const canvasRef = useRef<HTMLCanvasElement>(null);

  useEffect(() => {
    if (!canvasRef.current || !words || words.length === 0) {
      return;
    }

    const canvas = canvasRef.current;
    const ctx = canvas.getContext('2d');
    
    if (!ctx) return;

    // Clear canvas
    ctx.clearRect(0, 0, canvas.width, canvas.height);

    // Prepare data for wordcloud library
    const wordList = words.map(w => [w.text, w.value]);

    try {
      WordCloudLib(canvas, {
        list: wordList,
        gridSize: Math.round(16 * 600 / 1024),
        weightFactor: (size: number) => {
          return Math.pow(size, 2.3) * 600 / 1024;
        },
        fontFamily: 'Arial, sans-serif',
        color: () => {
          return `hsl(${Math.random() * 360}, 70%, 50%)`;
        },
        rotateRatio: 0.5,
        rotationSteps: 2,
        backgroundColor: 'transparent',
      });
    } catch (error) {
      console.error('Error rendering word cloud:', error);
    }
  }, [words, width, height]);

  if (!words || words.length === 0) {
    return (
      <div style={{ 
        height: `${height}px`, 
        display: 'flex', 
        alignItems: 'center', 
        justifyContent: 'center',
        border: '1px solid #e0e0e0',
        borderRadius: '4px',
      }}>
        <p>No data available</p>
      </div>
    );
  }

  return (
    <div style={{ 
      height: `${height}px`, 
      width: '100%',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      border: '1px solid #e0e0e0',
      borderRadius: '4px',
      backgroundColor: '#ffffff',
    }}>
      <canvas
        ref={canvasRef}
        width={width}
        height={height}
        style={{ maxWidth: '100%', height: 'auto' }}
      />
    </div>
  );
};

export default WordCloud;

